/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Results_To_DisplayInputs */

const en_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results to display`)
};

const fr_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat à afficher`)
};

const de_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse verfügbar`)
};

const it_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato da visualizzare`)
};

const ru_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты отсутствуют.`)
};

const es_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay resultados para mostrar`)
};

const zh_cn2_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无结果显示`)
};

const ja_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示する結果がありません`)
};

const hi_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दिखाने के लिए कोई परिणाम नहीं हैं`)
};

const pt_pt2_no_results_to_display = /** @type {(inputs: No_Results_To_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado para exibir.`)
};

/**
* | output |
* | --- |
* | "No results to display" |
*
* @param {No_Results_To_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_results_to_display = /** @type {((inputs?: No_Results_To_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Results_To_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_results_to_display(inputs)
	if (locale === "de") return de_no_results_to_display(inputs)
	if (locale === "it") return it_no_results_to_display(inputs)
	if (locale === "ru") return ru_no_results_to_display(inputs)
	if (locale === "es") return es_no_results_to_display(inputs)
	if (locale === "zh-CN") return zh_cn2_no_results_to_display(inputs)
	if (locale === "ja") return ja_no_results_to_display(inputs)
	if (locale === "hi") return hi_no_results_to_display(inputs)
	if (locale === "pt-PT") return pt_pt2_no_results_to_display(inputs)
	return en_no_results_to_display(inputs)
});